.card { display: flex; flex-direction: column; gap: 16px; min-width: 0; padding: 24px; border: var(--border-hair); background: var(--paper); }
.cardTitle { margin: 0; font-family: var(--font-cond); font-size: 34px; font-weight: 800; letter-spacing: -1.2px; line-height: 1; }
.zoneGroup { display: flex; flex-direction: column; gap: 8px; }
.zoneHead { display: flex; flex-wrap: wrap; align-items: baseline; justify-content: space-between; gap: 4px 12px; padding-bottom: 6px; border-bottom: var(--border-hair); }
.zoneTitle { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.4px; }
.zoneThreshold { font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--text-secondary); }
.zoneList { display: flex; flex-direction: column; gap: 6px; margin: 0; padding: 0; list-style: none; }
.zoneRow { display: grid; grid-template-columns: 150px 84px minmax(0, 1fr) 58px 36px; align-items: center; gap: 10px; font-family: var(--font-mono); font-size: 10px; letter-spacing: 0.6px; }
.zoneName { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
.zoneRange { color: var(--text-secondary); white-space: nowrap; }
.zoneTrack { height: 12px; background: var(--paper-2); }
.zoneBar { display: block; height: 100%; }
.zoneTime, .zonePct { text-align: right; }
.zoneTotal { align-self: flex-end; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--text-secondary); }
.zonesEmpty { margin: 0; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--text-secondary); }
.zonesEmpty a { color: var(--hot); text-decoration: underline; }

.card[data-tone='strong'] { border: var(--border-panel); }
.curveHead { display: flex; flex-wrap: wrap; align-items: flex-end; justify-content: space-between; gap: 12px 24px; }
.curveHeadText { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.curveSub { margin: 0; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--text-secondary); }
.curveLegend { display: flex; flex-wrap: wrap; gap: 8px 18px; margin: 0; padding: 0; list-style: none; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; }
.curveLegend li { display: flex; align-items: center; gap: 7px; }
.curveSwatch { display: inline-block; width: 18px; height: 3px; background: var(--hot); }
.curveSwatch[data-series='best'] { height: 2px; background: var(--ink); opacity: 0.45; }
.curveSwatch[data-series='marker'] { width: 10px; height: 10px; border: 2px solid var(--hot); border-radius: 50%; background: var(--paper); }

.hrStat { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--ink); }
.zonesNote { margin: 0; font-family: var(--font-sans); font-size: 12px; line-height: 1.45; color: var(--text-secondary); }

@media (max-width: 639px) {
  .card { padding: 16px; }
  .cardTitle { font-size: 26px; letter-spacing: -1px; }
  .zoneRow { grid-template-columns: 120px minmax(0, 1fr) 54px 32px; grid-template-areas: 'name track time pct' 'range range range range'; row-gap: 2px; }
  .zoneName { grid-area: name; }
  .zoneRange { grid-area: range; font-size: 9px; }
  .zoneTrack { grid-area: track; }
  .zoneTime { grid-area: time; }
  .zonePct { grid-area: pct; }
  .zonesEmpty a { display: inline-flex; align-items: center; min-height: 44px; min-width: 44px; }
  .curveHead { flex-direction: column-reverse; align-items: stretch; }
  .zonesNote { display: none; }
}
